export const timings = {
  start: 1,
  intro: true,
  add: 1,
  after: 2.5,
}

export const delayAfterFS = false
